/* build/tpl */
import deps from './deps/findValueDeep.js';
import getFindValueDeep from './getFindValueDeep.js';
export default getFindValueDeep(deps);
